import React from 'react';
import { connect } from 'react-redux';
// Popup imports
import LevelSettingsModeEnum from './enums';
import LevelSettingsMain from './mainContent';
import LevelSettingsGoal from './levelGoal';
import LevelSettingsView from './levelView';

class LevelSettings extends React.Component {
    getPopupContent = () => {
        const { properties } = this.props;
        
        switch(properties.mode) {
            case LevelSettingsModeEnum.MAIN : {
                return (
                    <LevelSettingsMain 
                        fromLevelGrid={properties.fromLevelGrid}
                        levelUuid={properties.levelUuid}
                    />
                );
            }
            case LevelSettingsModeEnum.LEVEL_GOAL : {
                return (
                    <LevelSettingsGoal 
                        fromLevelGrid={properties.fromLevelGrid}
                        levelUuid={properties.levelUuid}
                    />
                );
            }
            case LevelSettingsModeEnum.LEVEL_VIEW : {
                return (
                    <LevelSettingsView
                        initial={properties.initial}
                        fromLevelGrid={properties.fromLevelGrid}
                        levelUuid={properties.levelUuid}
                    />
                );
            }
            default: {
                return (<></>);
            }
        }
    }

    render = () => {
        return this.getPopupContent();
    }
}

LevelSettings.defaultProperties = {
    properties: {
        mode: LevelSettingsModeEnum.MAIN,
        initial: false,
        fromLevelGrid: false,
        levelUuid: undefined
    }
}

const mapStateToProps = state => ({
    popup: state.popup
});

export default connect(
    mapStateToProps
)(LevelSettings);